/* eslint-disable */
import Vue from "vue";
import Router from "vue-router";
// import config from '@/config/app'
import dummy from "@/views/dummy";
import view404 from "@/views/view404";
import accountManagerRoutes from "./accountManagerRoutes";
import dealerRoutes from "./dealerRoutes";
import pondlogsRoutes from "./pondlogsRoutes";
import adminRoutes from "./adminRoutes";
import authRoutes from "./authRoutes";
Vue.use(Router);

const routes = [
  dealerRoutes,
  pondlogsRoutes,
  adminRoutes,
  authRoutes,
  accountManagerRoutes,
  {
    path: "*",
    redirect: "404",
  },
  {
    path: "/404",
    name: "page404",
    component: view404,
    meta: {
      langKey: "PondLogs",
    },
  },
  {
    path: "/dummy",
    name: "dummy",
    component: dummy,
  },
];

const router = new Router({ mode: "history", routes });
export default router;
